<template>
  <div class="block_title">
    <div class="block_title__line"></div>
    <div class="block_title__text">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: "block_title",
  props: {
    title: {
      type: String,
      value: ""
    }
  }
};
</script>
